var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentLoader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "134px",
    height: "134px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#111d28",
    points: "31.6,19 13.9,19 5,34.3 13.9,49.7 31.6,49.7 40.4,34.3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.5;1",
    values: "1;0.5;1",
    begin: "0s"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#162331",
    points: "58.9,3.1 41.1,3.1 32.3,18.4 41.1,33.7 58.9,33.7 67.7,18.4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.5;1",
    values: "1;0.5;1",
    begin: "-0.14285714285714285s"
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1e2e3f",
    points: "58.9,34.6 41.1,34.6 32.3,50 41.1,65.3 58.9,65.3 67.7,50"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.5;1",
    values: "1;0.5;1",
    begin: "-0.2857142857142857s"
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#26374a",
    points: "58.9,66.3 41.1,66.3 32.3,81.6 41.1,96.9 58.9,96.9 67.7,81.6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.5;1",
    values: "1;0.5;1",
    begin: "-0.42857142857142855s"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1e334a",
    points: "86.1,50.6 68.4,50.6 59.6,65.9 68.4,81.2 86.1,81.2 95,65.9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.5;1",
    values: "1;0.5;1",
    begin: "-0.5714285714285714s"
  }))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#203750",
    points: "86.1,19 68.4,19 59.6,34.3 68.4,49.7 86.1,49.7 95,34.3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.5;1",
    values: "1;0.5;1",
    begin: "-0.7142857142857143s"
  }))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#283f5a",
    points: "31.6,50.6 13.9,50.6 5,65.9 13.9,81.2 31.6,81.2 40.4,65.9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    repeatCount: "indefinite",
    dur: "1s",
    keyTimes: "0;0.5;1",
    values: "1;0.5;1",
    begin: "-0.8571428571428571s"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLoader);
export default __webpack_public_path__ + "static/media/contentLoader.c030294ebb1ad33f15b2d63d94bcc191.svg";
export { ForwardRef as ReactComponent };